var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
import { greys } from "../../global/colors";
var Filter = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "transparent" : _b, props = __rest(_a, ["color"]);
    return (React.createElement(BaseSvgIcon, __assign({}, props, { size: 16, viewBox: "0 0 18 17" }),
        React.createElement("g", { id: "filter-icon", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("g", { id: "Comments-section-default", transform: "translate(-188.000000, -144.000000)", stroke: greys.mediumDark, strokeWidth: "1.3" },
                React.createElement("g", { id: "Group-2", transform: "translate(145.000000, 71.000000)" },
                    React.createElement("g", { id: "Group-3", transform: "translate(34.000000, 62.000000)" },
                        React.createElement("g", { id: "Filter", transform: "translate(9.000000, 11.968000)" },
                            React.createElement("path", { fill: color, d: "M17.12,0.49 C16.9992384,0.246580902 16.7517217,0.0918829239 16.48,0.09 L1.48,0.09 C1.20827833,0.0918829239 0.960761563,0.246580902 0.84,0.49 C0.715368756,0.732315485 0.742679754,1.02493332 0.91,1.24 L7.23,9.24 L7.23,14.42 C7.23318723,14.6807717 7.37907967,14.9188067 7.61,15.04 C7.71329655,15.0997421 7.83067424,15.1308127 7.95,15.13 C8.09583189,15.1336988 8.2391759,15.0917445 8.36,15.01 L10.36,13.63 C10.6371343,13.4212983 10.8030406,13.0968593 10.81,12.75 L10.81,9.17 L17.11,1.24 C17.2773202,1.02493332 17.3046312,0.732315485 17.18,0.49 L17.12,0.49 Z", id: "Path" }))))))));
};
export default Filter;
